export default __webpack_public_path__ + "static/GT-Haptik-Bold-2-2edfa99b4e167c7a8eab52f786132ff4.ttf";